import React, { useEffect, useState } from "react";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import Axios from "axios";
import { GetCandidateById } from "../apiconstants/constants";
import { Link, useLocation } from "react-router-dom";
import LoadingSpinner from "../helpers/loadingspinner";
function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const HomeViewAssessmentVideo = () => {
    let query = useQuery();
    const guid = query.get("Guid");
    const [currentVideoUrl, setCurrentVideoUrl] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    let Guid="";
    const userguid = localStorage.getItem("guid");
    const employerGuid = localStorage.getItem("employerGuid")
    const roleID = localStorage.getItem("roleID")
    
    if(roleID==3){
     Guid = employerGuid
    }
    else{
      Guid= userguid
    }
    
    const [candidateDetails, setCandidateDetails] = useState(null);
    const [showModal, setShowModal] = useState(false);


    const GetCandidateDetails = () => {
  setIsLoading(true);
  const GetapiUrl = GetCandidateById.APIURL;
  const fliterdata = { guid: guid };

  Axios.post(GetapiUrl, fliterdata)
    .then((result) => {
      setCandidateDetails(result.data);
    })
    .catch((error) => {
      console.error("Error fetching candidate details:", error);
    })
    .finally(() => {
      setIsLoading(false);
    });
};

 
    useEffect(() => {
        GetCandidateDetails();
    }, []);
   
    return (
        <>
            {isLoading ?  (
                <center><LoadingSpinner /></center>
            ) : (
               <div className="container-fluid "> 
               <div className='mb-3 mt-3' style={{ display: 'flex', alignItems: 'center' }}>
               <h2 style={{ color: "#00a7ac", marginLeft: '10px', marginBottom: '0', marginTop: '0' }}>Assessment Video</h2>
               </div>
               <hr />       
     <div
  className="iframe-container"
  style={{
    height: "500px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }}
>
  {candidateDetails?.videoURL ? (
    <iframe
      src={candidateDetails.videoURL}
      allow="autoplay; fullscreen"
      allowFullScreen
      style={{
        width: "90%",
        height: "70%",
        border: "none",
        marginLeft:'50px'
      }}
    ></iframe>
  ) : (
    <p style={{ color: "red" }}>No video available</p>
  )}
</div>

 
  </div>
                 
            ) }
        
        </>
    );
};

export default HomeViewAssessmentVideo;





